import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scroll-hint" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "scroll-hint-content has-mouse" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mouse" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mouse-wheel" })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Scroll door de geschiedenis")
], -1)
const _hoisted_3 = { class: "scroll-hint-content has-touch" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Swipe door de geschiedenis", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Icon, { name: "swipe" }),
      _hoisted_4
    ])
  ]))
}